import { AfterViewInit, Component, ElementRef, HostListener, OnInit } from '@angular/core';
import  'leaflet-gpx';
import * as L from 'leaflet';
import { Router } from '@angular/router';

@Component({
  selector: 'app-gerace',
  templateUrl: './gerace.component.html',
  styleUrls: ['./gerace.component.css']
})
export class GeraceComponent implements OnInit {

  isFixed = false;
  coordinates: any[] = [];
  map!: L.Map;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const div2Offset = document.getElementById('containerFoto')?.offsetTop || 0;
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (scrollPosition > div2Offset) {
      this.isFixed = true;
    } else {
      this.isFixed = false;
    }
  }

  constructor(
    private elementRef: ElementRef,
    private router: Router
  ) {}
 

  ngOnInit(): void {
    L.Icon.Default.imagePath = "assets/leaflet/";
    this.initializeMap();
    this.loadGPXFile('../../../assets/images/Itinerari-esperienze//04_Aspromonte/04_2_Canolo-Gerace-Gambarie/2023-12-10_1390148120_Canolo Nuova-Gerace-Gambarie.gpx');
  }

  initializeMap() {
    this.map = L.map(this.elementRef.nativeElement.querySelector('#map')).setView([51.505, -0.09], 13);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(this.map);
  }

  loadGPXFile(filePath: string) {
    new L.GPX(filePath, { async: true }).on('loaded', (e: any) => {
      this.map.fitBounds(e.target.getBounds());
    }).addTo(this.map);
  }

  goToCiclovia(){
    this.router.navigate(['pages/ciclovia-aspromonte']);
  }

  goToGerace(){
    this.router.navigate(['pages/gerace']);
  }

  goToAreaGrecanica(){
    this.router.navigate(['pages/area-grecanica']);
  }

}
